import { Dashboard as DashboardComponent } from "components/dashboard";
import { Navigate } from "react-router-dom";
import useMarketStrategy from "../strategies/market/useMarketStrategy";

const Dashboard = () => {
  const { marketHasStatisticsDashboard } = useMarketStrategy();
  return marketHasStatisticsDashboard ? (
    <DashboardComponent />
  ) : (
    <Navigate to="/" />
  );
};

export default Dashboard;
